export const MAX_MISTAKES = 4;

export const DIFFICULTY_COLORS = {
  0: "bg-connections-easy text-black",
  1: "bg-connections-medium text-white",
  2: "bg-connections-hard text-white",
  3: "bg-connections-hardest text-white",
} as const;

export const DIFFICULTY_LABELS = {
  0: "Easy",
  1: "Medium",
  2: "Hard",
  3: "Very Hard",
} as const;
